// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home_16VbE","column":"Home_column_19wwE","side":"Home_side_H5yoD","no_access":"Home_no_access_x5TcB","main":"Home_main_3dQVQ","maxResults":"Home_maxResults_2nUDh"};